import { NavLink } from 'react-router-dom';
import { Contact, Dashboard, Gift, Highlighter, Video } from '@/components/Icons.tsx';

const TABS = [
  { Icon: Dashboard, title: 'Dashboard', to: '/dashboard' },
  { Icon: Video, title: 'Videos', to: '/video-tutorials' },
  { Icon: Gift, title: 'Packages', to: '/packages' },
  { Icon: Contact, title: 'Contact', to: '/contact' },
  { Icon: Highlighter, title: 'Profile', to: '/profile' },
];

/**
 * The mobile counterpart of `Sidebar`. Hidden above 639px (and on landscape
 * phones it becomes a 48px bar with the labels still inline).
 */
const MobileTabBar = () => (
  <nav
    className="m:flex fixed bottom-0 left-0 right-0 z-40 hidden
               min-h-m-tabbar pb-safe bg-neutral2 border-t border-shade-10
               ml:min-h-12 ml:pb-0 ml:pl-safe ml:pr-safe"
  >
    {TABS.map(({ Icon, title, to }) => (
      <NavLink
        key={to}
        to={to}
        className={({ isActive }) =>
          `flex flex-1 flex-col items-center justify-center gap-0.5
           text-caption font-medium active:bg-shade-5
           ${isActive ? 'text-primary' : 'text-neutral2-text-softer'}`}
      >
        <Icon width={22} height={22} />
        {title}
      </NavLink>
    ))}
  </nav>
);

export default MobileTabBar;
